import React, { useState, useContext, useEffect } from "react";
import MonthPickerComponent from "../../Utils/MonthPickerComponent";
import xls from "../../images/xls/png/Group 47.png";
import line from "../../images/line.png";
import FileIcon from "../../images/file.png";
import FileIconBlur from "../../images/fileblur.png";
import Card from '../../Components/RE//ReListCard/Card'
import Table from '../../Components/RE/AllTableComponent'
import RefineSearch from '../../Components/RE/RefineSearchComponent'
import ReLayout from '../../Components/ReLayout'
import Constants from '../../Constants'
import ReInvestmentRefineSearch from '../../Components/RefineSearch/ReInvestmentRefineSearch'
import SavedFilterContent from "../../Components/SavedFilter";
import ExportPopup from "../../Components/ExportPopup";
import {reInvestmentExportData } from "../../Components/ExportPopup/ExportData"
import { reExportPDF } from "../../Config/config";
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import FilterTag from "../../Components/Tag";
import { UserContext } from "../../Contexts/UserContext";
import ExcelDownloader from "../../Components/shared/ExcelDownloader";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../../Components/ExportPopup/DownloadTrigger";

/**
 * The `REHome` function is a React component that renders a page for real estate investments,
 * including a filter section, a table of investments, and a sidebar for refining search options.
 * @param props - The `props` parameter is an object that contains the properties passed to the
 * `REHome` component. These properties can be accessed using dot notation, such as `props.active` to
 * access the `active` property.
 * @returns The REHome component is being returned.
 */
function REHome(props) {
    const [showPopup, setShowPopup] = useState(false);
    const { pathname } = useLocation(); 
    const { save, setSave, showMonthPicker,refineSearchFilters ,groupId, isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
    const {globalSearchResult} = useContext(TableDataContext);
    const [openTab, setOpenTab] = React.useState(1);
    const savedList = () => {
        setSave(!save)
    }
    useEffect(() => {
        setOpenTab(props.active) 
    }, [openTab])
    const {isStudent,isTrialExport} = useContext(UserContext) 
    const location = useLocation(); 
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const pathKey = location.pathname.split("/").slice(0, 3).join("/");
    useEffect(()=>{
        if (window.innerWidth < 800) {
            // setOpen(true);
            setIsMobile(true);
        }    },[])
    return (
        <>
            <ReLayout>
                <div className="flex min-h-screen h-screen flex-col">
                    <div className="flex min-h-0 flex-1 overflow-hidden">                        
                        <main className={`min-w-0 mt-14 flex-1 md:border-t border-gray-200 flex `}>
                            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                                <div></div>
                                <div className="pl-3 pr-4 lg:pr-4 md:pr-[0.7rem]">
                                    <div className=" ">
                                        <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between ">

                                           <div></div>

                                                <div className={"justify-between items-center px-2 py-2 space-x-4 "+(showMonthPicker!=0 ? 'md:flex':'flex')}>
                                                    <div></div>
                                                    <div className={showMonthPicker!=0 ?"hidden md:flex space-x-3":"flex space-x-3"}>   
                                                    {isStudent == 'true' ? <></>  : 
                                                    <>
                                                                <button> 
                                                                    {
                                                                    isTrialExport=='false' ?
                                                                        <ExcelDownloader
                                                                        url={reExportPDF}
                                                                        fileName={Constants.exportNames.re_company_investment}
                                                                        data={{"type" : "re-investments"}}  
                                                                        children={
                                                                            <DownloadTrigger />
                                                                        }                   
                                                                        />
                                                                        :

                                                                        <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                                                    }
                                                                    
                                                                    {showPopup && (
                                                                        <ExportPopup
                                                                            modules="re-company"
                                                                            fileName={Constants.exportNames.re_company_investment}
                                                                            url={reExportPDF}
                                                                            onClose={() => setShowPopup(false)}
                                                                            exportOptions={reInvestmentExportData}
                                                                            type="re-investments"
                                                                            />
                                                                    
                                                                    )}
                                                                </button>
                                                        </>
                                                        }

                                                    </div>                                                
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className='overflow-y-auto'>
                                    <Table menu="re" page="list" sub_type_master_id={Constants.subCategoryIds.re_investments_id}/>
                                </div>
                            </section>
                        </main>
                    </div>


                </div>
            </ReLayout>
        </>
    )
}

export default REHome
